import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postNote } from '../../services/NotesService';
import { Note, PostNoteRequest } from '../../types/Notes';

type Result = UseMutationResult<Note, Error, PostNoteRequest>;

function usePostNote(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postNote, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['notes'] });
      queryClient.invalidateQueries({ queryKey: ['notes-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostNote;
